import { render, staticRenderFns } from "./MaterialPage.vue?vue&type=template&id=1197c33e"
import script from "./MaterialPage.vue?vue&type=script&lang=js"
export * from "./MaterialPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports